export default (key) => {
    fetch("/t", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            path: window.location.pathname,
            key
        })
    })
        .then();
    return null;
};
